<ng-container *ngIf="render$ | async" />

<div id="groove-form" class="flex flex-col justify-center items-stretch">
  <!-- TOP -->
  <div class="mb-2 flex flex-row space-x-2 justify-center items-center">
    <csl-groove-plate-selector
      [disabled]="!outline.topSide.groove || !editable"
      [plate]="getPlate(outline.topSide.groove)"
      (plateChange)="setPlate(outline.topSide.groove, $event)">
    </csl-groove-plate-selector>
    <csl-groove-select
      [editable]="editable"
      [position]="'top'"
      [fullPanelThickness]="fullPanelThickness"
      [selected]="outline.topSide.groove"
      (selectedChange)="outline.topSide.groove = $event; formChanged.emit(getGrooves())"
      class="flex flex-col basis-1/5"></csl-groove-select>
  </div>
  <!-- / TOP -->

  <div class="flex flex-row space-x-2 justify-center items-center">
    <!-- LEFT -->
    <div class="flex flex-col space-y-2 items-stretch">
      <csl-groove-select
        [editable]="editable"
        [position]="'left'"
        [fullPanelThickness]="fullPanelThickness"
        [selected]="outline.leftSide.groove"
        (selectedChange)="outline.leftSide.groove = $event; formChanged.emit(getGrooves())"
        class="flex flex-col basis-1/5"></csl-groove-select>
      <csl-groove-plate-selector
        [disabled]="!outline.leftSide.groove || !editable"
        [plate]="getPlate(outline.leftSide.groove)"
        (plateChange)="setPlate(outline.leftSide.groove, $event)">
      </csl-groove-plate-selector>
    </div>
    <!-- / LEFT -->

    <csl-svg-workspace #svgWorkspace [p]="panel"></csl-svg-workspace>

    <!-- RIGHT -->
    <div class="flex flex-col space-y-2 items-stretch">
      <csl-groove-select
        [editable]="editable"
        [position]="'right'"
        [fullPanelThickness]="fullPanelThickness"
        [selected]="outline.rightSide.groove"
        (selectedChange)="outline.rightSide.groove = $event; formChanged.emit(getGrooves())"
        class="flex flex-col basis-1/5"></csl-groove-select>
      <csl-groove-plate-selector
        [disabled]="!outline.rightSide.groove || !editable"
        [plate]="getPlate(outline.rightSide.groove)"
        (plateChange)="setPlate(outline.rightSide.groove, $event)">
      </csl-groove-plate-selector>
    </div>
    <!-- / RIGHT -->
  </div>

  <!-- BOTTOM -->
  <div class="flex flex-row space-x-2 justify-center items-center">
    <csl-groove-plate-selector
      [disabled]="!outline.bottomSide.groove || !editable"
      [plate]="getPlate(outline.bottomSide.groove)"
      (plateChange)="setPlate(outline.bottomSide.groove, $event)">
    </csl-groove-plate-selector>
    <csl-groove-select
      [editable]="editable"
      [position]="'bottom'"
      [fullPanelThickness]="fullPanelThickness"
      [selected]="outline.bottomSide.groove"
      (selectedChange)="outline.bottomSide.groove = $event; formChanged.emit(getGrooves())"
      class="flex flex-col basis-1/5"></csl-groove-select>
  </div>
  <!-- / BOTTOM -->
</div>
